export const normalizeAvatarSrc = (
  avatarSrc: string | null | undefined
): string => {
  const normalized = (avatarSrc ?? "").trim();
  if (!normalized || normalized === "/") return "";
  return normalized;
};
